import React from "react"
import './chatbot.scss'

const ChatBot=()=>{
    return(
        <iframe
          src="https://dtech.marimo.seqrops.in?access_token=brt@marimo"
          style={{height: "88%",width:'100%'}}
          title="Marimo Chat"
          loading={"eager"}
        />       
    )
}
export default ChatBot